function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Y from 'yjs';
import { chunk } from 'lodash';
import { ElementModel } from './ElementModel';
import { EditorConfig } from '../../edit/EditorConfig';
export class StraightLineModel extends ElementModel {
  get drawPoints() {
    if (this.localPoints.length >= 4) {
      return this.localPoints;
    }
    return this.points;
  }
  constructor(root, scope, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", true);
    _defineProperty(this, "shouldUseLocalPoints", true);
    _defineProperty(this, "localPointsPick", 4);
    if (this.root.doc && !this.root.has('type')) {
      this.root.set('type', 'line');
    }
    if (this.root.doc && !this.root.has('points')) {
      this.root.set('points', new Y.Array());
    }
  }
  liveCursorPoint() {
    const yArray = this.root.get(ElementModel.KEYS.points);
    if (yArray.length < 2) {
      return null;
    }
    const len = yArray.length;
    const point = new this.scope.Point(yArray.get(len - 2), yArray.get(len - 1));
    return point.transform(new this.scope.Matrix(this.pointsMatrix));
  }
  subDispose() {}
  onVectorUpdate() {
    if (!this.item) {
      return;
    }
    this.item.removeSegments();
    const path = this.renderLine();
    this.item.addSegments(path.segments);
  }
  renderLine() {
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    const papperPoints = chunk(this.drawPoints, 2).map(item => {
      return new this.scope.Point(item[0], item[1]).transform(matrix);
    });
    const path = new this.scope.Path();
    path.moveTo(papperPoints[0]);
    path.lineTo(papperPoints[1] ?? papperPoints[0]);
    return path;
  }
  createPaperItem() {
    this.item = this.renderLine();
    this.item.strokeJoin = 'bevel';
    this.item.strokeColor = new this.scope.Color(this.strokeColor);
    this.item.dashArray = this.dashArray;
    this.item.strokeWidth = this.strokeWidth;
  }
  editorConfig() {
    const cfg = new EditorConfig();
    cfg.resizeModel = () => 'horizontal';
    cfg.controlPoints.push({
      name: 'line-start',
      getPosition: () => {
        const matrix = new this.scope.Matrix(this.pointsMatrix);
        const points = this.drawPoints;
        const start = new this.scope.Point(points[0], points[1]);
        return this.scope.project.view.projectToView(start.transform(matrix));
      },
      onPositionChange: point => {
        if (!this.item) {
          return;
        }
        const pointsMatrix = new this.scope.Matrix(this.pointsMatrix);
        const trPoint = point.transform(pointsMatrix.inverted());
        const oldPoints = this.drawPoints;
        this.setPoints([trPoint.x, trPoint.y, oldPoints[2], oldPoints[3]]);
      }
    });
    cfg.controlPoints.push({
      name: 'line-end',
      getPosition: () => {
        const matrix = new this.scope.Matrix(this.pointsMatrix);
        const points = this.drawPoints;
        const end = new this.scope.Point(points[2], points[3]);
        return this.scope.project.view.projectToView(end.transform(matrix));
      },
      onPositionChange: point => {
        if (!this.item) {
          return;
        }
        const pointsMatrix = new this.scope.Matrix(this.pointsMatrix);
        const trPoint = point.transform(pointsMatrix.inverted());
        const oldPoints = this.drawPoints;
        this.setPoints([oldPoints[0], oldPoints[1], trPoint.x, trPoint.y]);
      }
    });
    return cfg;
  }
  vectorKeys() {
    return [];
  }
  styleKeys() {
    return {
      include: [],
      exclude: ['fillColor']
    };
  }
  onStyleKeyUpdate(_key) {
    if (!this.item) {
      return;
    }
    this.item.removeSegments();
    const path = this.renderLine();
    this.item.addSegments(path.segments);
  }
}